import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/approval.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleReviewCancelEvent } from './Types'
import { Link } from 'react-router-dom'
import { stopPropagation } from 'utils'

interface Props extends ActivityEventPosition {
  event: ArticleReviewCancelEvent
}

const ArticleReviewCancel = ({ event, ...props }: Props) => {
  const { user, article, data } = event
  const { base_branch, branch } = data

  const isBaseBranch = base_branch.key === article.key

  const content = isBaseBranch ? (
    <>
      <Actor displayName={user.display_name || 'Anonymous user'} userId={user?.id} /> ended the approval request on this
      linked copy:{' '}
      <Link to={branch.url} onClick={stopPropagation}>
        {branch.title}
      </Link>
    </>
  ) : (
    <>
      <Actor displayName={user.display_name || 'Anonymous user'} userId={user?.id} /> ended the approval request
    </>
  )

  return <BaseActivityEvent {...props} icon={<Icon />} timestamp={event.timestamp} content={content} />
}

export { ArticleReviewCancel }
